import SkillScore from './model';
import create from './create';

SkillScore.create = create;

export default SkillScore;



// WEBPACK FOOTER //
// ./data/AcademicInfo/SkillScore/index.js